import client from '@/api/client';

import crudlModuleGenerator from '@/_CRUDL/modules/generator';

import { SORT_METHODS } from '@sdk/views/Invitations/List/status';

export const BATCH_INVITATIONS_START = 'users/invitations/START';
export const BATCH_INVITATIONS_SUCCESS = 'users/invitations/SUCCESS';
export const BATCH_INVITATIONS_FAILURE = 'users/invitations/FAILURE';

export const INITIAL_INVITATIONS_FILTERS = {
  CRUDL_append: false,
  email: '',
  invitation_accepted: null,
  sort: SORT_METHODS.invitation_sent_at_desc.value,
  page: 1,
  per_page: 20,
};

const invitations = crudlModuleGenerator('userInvitations');

export default {
  ...invitations,

  state: {
    ...invitations.state,

    list: {
      ...invitations.state.list,

      filters: {
        ...INITIAL_INVITATIONS_FILTERS,
      },
    },

    batch: {
      error: null,
      loading: false,
      result: {},
    },
  },

  actions: {
    ...invitations.actions,

    batch({ commit }, payload) {
      commit(BATCH_INVITATIONS_START);

      return new Promise((resolve, reject) => {
        client.post('/user_invitations/batch', payload)
          .then((response) => {
            commit(BATCH_INVITATIONS_SUCCESS, response);
            resolve(response);
          })
          .catch((error) => {
            commit(BATCH_INVITATIONS_FAILURE, error);
            reject(error);
          });
      });
    },
  },

  mutations: {
    ...invitations.mutations,

    [BATCH_INVITATIONS_START](state) {
      state.batch.error = null;
      state.batch.loading = true;
      state.batch.result = {};
    },
    [BATCH_INVITATIONS_SUCCESS](state, response) {
      state.batch.error = null;
      state.batch.loading = false;
      state.batch.result = response.data;
    },
    [BATCH_INVITATIONS_FAILURE](state, error) {
      let details = error;

      try {
        details = error.response.data.error;
      } catch (err) { /* */ }

      state.batch.error = details;
      state.batch.loading = false;
      state.batch.result = {};
    },
  },
};
